import appConfig from '../../../configs/appConfig';
import objectUtil from '../../../utils/objectUtil';
import logLevels from '../logLevels';
import logState from '../logState';

const getMinLogLevel = () => {
    const minLogLevel = appConfig.getConsoleLogConfig().level;
    const level = logLevels[minLogLevel] ?? logLevels.ERROR;

    return level;
};

const formatLogMessage = (logLevel, msg, error) => {
    const date = new Date().toISOString();
    const dateFormatted = date.substr(11, 12);
    const errorMsg = prepareErrorMessage(error);

    return `${dateFormatted} | ${logLevel.name} | ${msg}${errorMsg}`;
};

const prepareErrorMessage = (error) => {
    let errorMessage = '';

    if (!error || error === 'undefined') return errorMessage;

    if (objectUtil.isObject(error)) {
        if (error?.config?.headers && objectUtil.isObject(error.config.headers)) {
            for (const key of Object.keys(error.config.headers)) {
                error.config.headers[key] = 'n/a';
            }
        }

        errorMessage = JSON.stringify(error, Object.getOwnPropertyNames(error));
    } else {
        errorMessage = error;
    }

    return ` | Error: ${errorMessage}`;
};

const log = (logLevel, msg, data) => {
    const minLevel = getMinLogLevel();

    if (logLevel.id < minLevel.id) return;

    logState.setLogState(formatLogMessage(logLevel, msg, data));

    if (logLevel.id < logLevels.WARN.id) {
        console.log(formatLogMessage(logLevel, msg, data));
    } else if (logLevel.id === logLevels.WARN.id) {
        console.warn(formatLogMessage(logLevel, msg, data));
    } else {
        console.error(formatLogMessage(logLevel, msg, data));
    }
};

const consoleLogger = {
    trace: (msg) => {
        log(logLevels.TRACE, msg);
    },
    debug: (msg) => {
        log(logLevels.DEBUG, msg);
    },
    info: (msg) => {
        log(logLevels.INFO, msg);
    },
    warn: (msg, error) => {
        log(logLevels.WARN, msg, error);
    },
    error: (msg, error) => {
        log(logLevels.ERROR, msg, error);
    },
    fatal: (msg, error) => {
        log(logLevels.FATAL, msg, error);
    },
    log,
};

export default consoleLogger;
